export enum ClassificationRulesTypes {
  GetAllClassificationRulesRequest = 'classificationRules.GetAllClassificationRulesRequest',
  GetAllClassificationRulesSuccess = 'classificationRules.GetAllClassificationRulesSuccess',
  GetAllClassificationRulesFailure = 'classificationRules.GetAllClassificationRulesFailure',
  SetClassificationRuleRequest = 'classificationRules.setClassificationRuleRequest',
  SetClassificationRuleSuccess = 'classificationRules.setClassificationRuleSuccess',
  SetClassificationRuleFailure = 'classificationRules.setClassificationRuleFailure',
  DeleteClassificationRuleRequest = 'classificationRules.deleteClassificationRuleRequest',
  DeleteClassificationRuleSuccess = 'classificationRules.deleteClassificationRuleSuccess',
  DeleteClassificationRuleFailure = 'classificationRules.deleteClassificationRuleFailure',
}
